import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';
import { SelectOptionsInterface } from '../../types';

@Component({
  selector: 'ui-chip-select',
  templateUrl: './chip-select.component.html',
  styleUrl: './chip-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChipSelectComponent {
  data = input.required<SelectOptionsInterface[]>();
  selectedIds = input<string[]>([]);

  selectionChange = output<string[]>();

  currentSelectedIds = signal<string[]>([]);

  constructor() {
    effect(() => {
      this.currentSelectedIds.set([...this.selectedIds()]);
    });
  }

  toggle(id: string): void {
    const current = this.currentSelectedIds();
    if (current.includes(id)) {
      this.currentSelectedIds.set(current.filter((i) => i !== id));
    } else {
      this.currentSelectedIds.set([...current, id]);
    }
    this.selectionChange.emit(this.currentSelectedIds());
  }

  isSelected(id: string): boolean {
    return this.currentSelectedIds().includes(id);
  }
}
